import React, { Component } from 'react';
import styled from 'styled-components';
import { animated } from 'react-spring';

const Container = styled.div`
  position: relative;
  background: white;
  border-radius: 0.5rem;
  padding: ${({ padded }) => (typeof padded === 'undefined' ? '0rem' : typeof padded === 'boolean' ? '2rem' : padded)};
  padding-top: ${({ withCloseButton }) => (withCloseButton ? '3rem' : '0')};
`;

const AnimatedBox = animated(styled.div`
  align-self: center;
  justify-self: center;
  width: 100%;
  max-width: ${({ width }) => width || '500px'};
  margin: 2rem 0;
`);

export default class Dialog extends Component {
  ref = React.createRef();

  componentDidMount() {
    this.props.modal.setContentHeight(this.ref.current.parentNode.scrollHeight);
  }

  render() {
    const { style, width, ...props } = this.props;
    return (
      <AnimatedBox width={width} style={style}>
        <Container ref={this.ref} {...props} />
      </AnimatedBox>
    );
  }
}
